import { createFileRoute } from '@tanstack/react-router'

import type { PerfilId } from '@/lib/visoes'

import { PaginaProjetos } from '@/features/projetos/pagina'

export const Route = createFileRoute('/$perfil/projetos/')({
  component: Tela,
})

function Tela() {
  const { perfil } = Route.useParams()
  return <PaginaProjetos perfil={perfil as PerfilId} />
}
